const mainMenuItems = [
    "home",
    "about",
    "services",
    "blog",
    "contact"
]

export {mainMenuItems}